import type { TFunction } from 'i18next';

const U3204_I18N_NS = 'u3204';

const U3204_KNOWN_TOOL_I18N_KEYS: Record<string, string> = {
  search_projects: 'tools.search_projects',
  get_project_summary: 'tools.get_project_summary',
  generate_excel_report: 'tools.generate_excel_report',
  generate_word_document: 'tools.generate_word_document',
  generate_pdf_report: 'tools.generate_pdf_report',
};

export function u3204ResolveToolLabelKey(toolName: string): string {
  return U3204_KNOWN_TOOL_I18N_KEYS[toolName] ?? toolName;
}

export function u3204FormatToolLabel(toolName: string, t: TFunction): string {
  const key = u3204ResolveToolLabelKey(toolName);
  if (key === toolName) {
    return toolName;
  }
  return t(key, { ns: U3204_I18N_NS, defaultValue: toolName });
}
